import { TemplateFieldTypes } from "../../../Shared/Models/TemplateFieldTypes";
import { app } from "../../../../../Frame/App";
import { IFieldEdit } from "../../../Shared/Models/IFieldEdit";
import { LanguageString } from "../../../../../Model/LanguageString";
import { Template } from "./Template";
import { ITemplateFieldListItem } from "../../../../../Model/IListItem";

export abstract class TemplateFieldBase implements IFieldEdit {
    nameAll: LanguageString;
    descriptionAll: LanguageString;
    descriptionShowType: number;
    public type: TemplateFieldTypes;
    public pos: number;
    public templateId: number;
    public templateBlockId: number;
    public attributesJson: string;
    public short: string;
    public dependencies: string;
    public isMandatory: boolean;
    public isRelevantForReporting: boolean;
    public isDeleted: boolean;
    public isModified: boolean;
    public isHidden: boolean;
    public oldId: number;
    public className: "TemplateLocalField" | "TemplateCategoryField" | "TemplateGlobalField";
    public templateBlockGuid: string;
    public guid: string;
    public uniqueId: string;
    public freeze: boolean;
    public internalName: string;
    public useFieldRights: boolean;
    public visibilityByFieldRights: boolean;
    public isGlobalField: boolean;

    // local properties
    public canDelete: boolean = true;
    public canDropOnStatus: boolean = true;
    public canDropOnCommon: boolean = true;
    public canBeMandatory: boolean = true;
    abstract getName(): string;

    // type name
    public get typeName(): string {
        switch (this.type) {
            case TemplateFieldTypes.Benutzer:
                return Resources["TemplateEditClient"]["templateFieldBenutzer"];

            case TemplateFieldTypes.Bild:
                return Resources["TemplateEditClient"]["templateFieldBild"];

            case TemplateFieldTypes.BlockDate:
                return Resources["TemplateEditClient"]["templateFieldBlockDate"];

            case TemplateFieldTypes.BlockFinished:
                return Resources["TemplateEditClient"]["templateFieldBlockFinished"];

            case TemplateFieldTypes.BlockResponsible:
                return Resources["TemplateEditClient"]["templateFieldBlockResponsible"];

            case TemplateFieldTypes.Category:
                return Resources["TemplateEditClient"]["templateFieldCategory"];

            case TemplateFieldTypes.Datum:
                return Resources["TemplateEditClient"]["templateFieldDatum"];

            case TemplateFieldTypes.JaNein:
                return Resources["TemplateEditClient"]["templateFieldJaNein"];

            case TemplateFieldTypes.ManualAmpel:
                return Resources["TemplateEditClient"]["templateFieldManualAmpel"];

            case TemplateFieldTypes.CustomAmpel:
                return Resources["TemplateEditClient"]["templateFieldCustomAmpel"];

            case TemplateFieldTypes.Matrix:
                return Resources["TemplateEditClient"]["templateFieldMatrix"];

            case TemplateFieldTypes.Mehrzeilig:
                return Resources["TemplateEditClient"]["templateFieldMehrzeilig"];

            case TemplateFieldTypes.Responsible:
                return Resources["TemplateEditClient"]["templateFieldResponsible"];

            case TemplateFieldTypes.RichText:
                return Resources["TemplateEditClient"]["templateFieldRichText"];

            case TemplateFieldTypes.SerialMeasure:
                return Resources["TemplateEditClient"]["templateFieldSerialMeasure"];

            case TemplateFieldTypes.Textzeile:
                return Resources["TemplateEditClient"]["templateFieldTextzeile"];

            case TemplateFieldTypes.Title:
                return Resources["TemplateEditClient"]["templateFieldTitle"];

            case TemplateFieldTypes.Trennlinie:
                return Resources["TemplateEditClient"]["templateFieldTrennlinie"];

            case TemplateFieldTypes.Zahl:
                return Resources["TemplateEditClient"]["templateFieldZahl"];

            case TemplateFieldTypes.TimeFromTo:
                return Resources["TemplateEditClient"]["templateFieldTimeFromTo"];

            case TemplateFieldTypes.UserList:
                return Resources["TemplateEditClient"]["templateFieldUserList"];

            case TemplateFieldTypes.NotesList:
                return Resources["TemplateEditClient"]["templateFieldNotesList"];

            case TemplateFieldTypes.ProjectNumber:
                return Resources["_TabStructurePartial"]["fortlaufendeNummer"];

            case TemplateFieldTypes.DateDiff:
                return Resources["_TabStructurePartial"]["dateDiff"];

            case TemplateFieldTypes.ParentContentText:
                return Resources["_TabStructurePartial"]["parentContent"];

            case TemplateFieldTypes.ParentContentNumber:
                return Resources["_TabStructurePartial"]["parentContentNumber"];

            case TemplateFieldTypes.ParentContentUser:
                return Resources["_TabStructurePartial"]["parentContentUser"];

            case TemplateFieldTypes.ParentContentUserList:
                return Resources["_TabStructurePartial"]["parentContentUserList"];

            case TemplateFieldTypes.ParentContentDate:
                return Resources["_TabStructurePartial"]["parentContentDate"];

            case TemplateFieldTypes.Escalation:
                return Resources["_TabStructurePartial"]["escalation"];

            case TemplateFieldTypes.DataTemplatesMeasureList:
                return Resources["_TabStructurePartial"]["dataTemplatesMeasureList"];

            case TemplateFieldTypes.CustomButton:
                return Resources["_TabStructurePartial"]["customButton"];

            case TemplateFieldTypes.S2030Approval:
                return "S2030 Approval";

            case TemplateFieldTypes.S2030Workpackages:
                return "S2030 Workpackages";

            case TemplateFieldTypes.S2030Documents:
                return "S2030 Documents";

            case TemplateFieldTypes.S2030Activities:
                return "S2030 Activities";

            case TemplateFieldTypes.S2030Ampel:
                return "S2030 Ampel";

            case TemplateFieldTypes.S2030Goals:
                return "S2030 Goals";

            case TemplateFieldTypes.S2030StatusUpdate:
                return "S2030 Status Update";

            case TemplateFieldTypes.S2030Milestones:
                return "S2030 Milestones";

            case TemplateFieldTypes.S2030TopKpis:
                return "S2030 TOP Kpis";

            case TemplateFieldTypes.S2030MapStrategy:
                return "S2030 Maping";

            case TemplateFieldTypes.HarveyBall:
                return "Harvey Ball";

            case TemplateFieldTypes.AuditFindingData:
                return "Auditdaten";

            case TemplateFieldTypes.AuditPlanMeasures:
                return "Auditdaten";

            case TemplateFieldTypes.AuditDoMeasures:
                return "Maßnahmen";

            case TemplateFieldTypes.PlannedAudits:
                return "geplante Audits";

            case TemplateFieldTypes.AuditProcesses:
                return "Auditierte Prozesse";

            case TemplateFieldTypes.Documents:
                return "Dokumente";

            case TemplateFieldTypes.MeasureList:
                return "Maßnahmenliste";

            case TemplateFieldTypes.ColorPicker:
                return "Farbauswahl";

            case TemplateFieldTypes.StrategyFinanceRating:
                return "Ampellogik/Rangzahl";

            case TemplateFieldTypes.Email:
                return Resources["_TabStructurePartial"]["email"];

            case TemplateFieldTypes.ParentStatus:
                return Resources["_TabStructurePartial"]["statusOfParentId"];

            case TemplateFieldTypes.KurarayVorlage:
                return "Kuraray Vorlage";

            case TemplateFieldTypes.LinkMeasures:
                return Resources["TemplateEditClient"]["linkMeasures"];

            case TemplateFieldTypes.PagPcmsSelfCheckYesNo:
                return "Self-Check Yes/No";

            case TemplateFieldTypes.DataFromSubmeasures:
                return Resources["TemplateEditClient"]["dataFromSubmeasures"];

            case TemplateFieldTypes.ExternalInterface:
                return Resources["TemplateEditClient"]["externalInterface"];

            default:
                return "unknown template field type: " + this.type;
                break;
        }
    }

    // name
    public get name(): string {
        return this.getName();
    }

    // dependency
    public get dependencyName(): string {
        return "TODO: dependency name";
    }

    public init() {
        switch (this.type) {
            case TemplateFieldTypes.Mehrzeilig:
            case TemplateFieldTypes.Textzeile:
            case TemplateFieldTypes.Zahl:
            case TemplateFieldTypes.Category:
            case TemplateFieldTypes.Benutzer:
            case TemplateFieldTypes.Bild:
            case TemplateFieldTypes.Datum:
            case TemplateFieldTypes.DateDiff:
            case TemplateFieldTypes.JaNein:
            case TemplateFieldTypes.RichText:
            case TemplateFieldTypes.Trennlinie:
            case TemplateFieldTypes.TimeFromTo:
            case TemplateFieldTypes.UserList:
            case TemplateFieldTypes.Documents:
            case TemplateFieldTypes.MeasureList:
            case TemplateFieldTypes.DataTemplatesMeasureList:
            case TemplateFieldTypes.ColorPicker:
            case TemplateFieldTypes.ProjectNumber:
            case TemplateFieldTypes.StrategyFinanceRating:
            case TemplateFieldTypes.ParentContentText:
            case TemplateFieldTypes.ParentContentNumber:
            case TemplateFieldTypes.ParentContentUser:
            case TemplateFieldTypes.ParentContentUserList:
            case TemplateFieldTypes.ParentContentDate:
            case TemplateFieldTypes.S2030Approval:
            case TemplateFieldTypes.S2030Workpackages:
            case TemplateFieldTypes.S2030Activities:
            case TemplateFieldTypes.S2030Ampel:
            case TemplateFieldTypes.S2030Goals:
            case TemplateFieldTypes.S2030StatusUpdate:
            case TemplateFieldTypes.S2030Milestones:
            case TemplateFieldTypes.S2030TopKpis:
            case TemplateFieldTypes.S2030Documents:
            case TemplateFieldTypes.S2030MapStrategy:
            case TemplateFieldTypes.HarveyBall:
            case TemplateFieldTypes.Escalation:
            case TemplateFieldTypes.Email:
            case TemplateFieldTypes.ParentStatus:
            case TemplateFieldTypes.KurarayVorlage:
            case TemplateFieldTypes.CustomAmpel:
            case TemplateFieldTypes.NotesList:
            case TemplateFieldTypes.LinkMeasures:
            case TemplateFieldTypes.PagPcmsSelfCheckYesNo:
            case TemplateFieldTypes.DataFromSubmeasures:
            case TemplateFieldTypes.CustomButton:
            case TemplateFieldTypes.ExternalInterface:
                break;

            case TemplateFieldTypes.Title:
            case TemplateFieldTypes.Matrix:
            case TemplateFieldTypes.ManualAmpel:
            case TemplateFieldTypes.SerialMeasure:
                this.canDropOnStatus = false;
                break;
            case TemplateFieldTypes.BlockDate:
            case TemplateFieldTypes.BlockFinished:
            case TemplateFieldTypes.BlockResponsible:
                this.canDropOnCommon = false;
                this.canDropOnStatus = false;

                break;
            case TemplateFieldTypes.Responsible:
                this.canDelete = false;
                this.canDropOnStatus = false;
                break;

            case TemplateFieldTypes.AuditFindingData:
            case TemplateFieldTypes.AuditPlanMeasures:
            case TemplateFieldTypes.AuditDoMeasures:
            case TemplateFieldTypes.PlannedAudits:
            case TemplateFieldTypes.AuditProcesses:
                this.canDelete = false;
                this.canDropOnStatus = false;
                break;

            default:
                app.addError(Resources._PopupFieldEdit.unknownTemplateFieldMessage + ": " + this.type);
                break;
        }
        if (this.type == TemplateFieldTypes.Trennlinie ||
            this.type == TemplateFieldTypes.Matrix ||
            this.type == TemplateFieldTypes.ProjectNumber ||
            this.type == TemplateFieldTypes.SerialMeasure ||
            this.type == TemplateFieldTypes.DateDiff ||
            this.type == TemplateFieldTypes.ParentContentUser ||
            this.type == TemplateFieldTypes.ParentContentUserList ||
            this.type == TemplateFieldTypes.ParentContentText ||
            this.type == TemplateFieldTypes.ParentContentNumber ||
            this.type == TemplateFieldTypes.ParentContentDate ||
            this.type == TemplateFieldTypes.BlockFinished ||
            this.type == TemplateFieldTypes.DataTemplatesMeasureList) {
            this.canBeMandatory = false;
        }
    }
}
